import { useEffect } from "react";

const createEventDispatcher = (eventName) => (data) =>
  document.dispatchEvent(new CustomEvent(eventName, { detail: data }));

// Hook to add and clean up event listeners
export function useEvent(eventName, handler) {
  useEffect(() => {
    document.addEventListener(eventName, handler);
    return () => {
      document.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
}

// @deprecated — use mutateDashboardInfluencer(route) from src/hooks instead
export const refreshActiveInfluencerEventName = "active_influencer::refresh";
// @deprecated — use mutateDashboardInfluencer(route) from src/hooks instead
export const refreshActiveInfluencer = createEventDispatcher(
  refreshActiveInfluencerEventName,
);

export const refreshShopSetupStatusEventName = "shop_setup::refresh";
export const refreshShopSetupStatus = createEventDispatcher(
  refreshShopSetupStatusEventName,
);
